// extracted by mini-css-extract-plugin
module.exports =  {"endButton":"endButton_s8MkBXUC"};